import {SnackbarContent, CustomContentProps} from "notistack";
import React from "react";



const CustomDefault = React.forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => {

    const {
        message
    } = props

    return (
        <SnackbarContent ref={ref}>
            <div className="alert alert--secondary alert--alt" style={{minWidth: "250px"}}>
                <div className="alert__header">{message}</div>
            </div>
        </SnackbarContent>
    )
})

export {CustomDefault}